"use client";

import { useState } from "react";
import { Tab, Tabs } from "@nextui-org/react";
import NosProduitsCard, { NosProduitsCardProps } from "./NosProduitsCard";

export default function NosProduitsTab({ tabs }: { tabs: NosProduitsCardProps[] }) {
  const [selected, setSelected] = useState(tabs[0]?.tabLabel || "");

  return (
    <Tabs
      aria-label="Options"
      selectedKey={selected}
      onSelectionChange={(key) => setSelected(key.toString())}
      variant="bordered"
      size="lg"
      items={tabs}
      classNames={{
        tabList: "flex-col lg:flex-row border-foreground gap-2",
        cursor: "dark:bg-foreground light:bg-background bg-foreground",
        tabContent: "text-foreground-900 group-data-[selected=true]:text-background xl:text-xl font-bold",
        tab: "py-6 px-6",
      }}
    >
      {(tab) => (
        <Tab
          key={tab.tabLabel}
          title={tab.tabLabel}
          aria-selected={selected === tab.tabLabel ? "true" : "false"}
        >
          <NosProduitsCard {...tab} />
        </Tab>
      )}
    </Tabs>
  );
}
